import styled from "styled-components";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

import { TypographyProps } from "./Typography.contants";

// eslint-disable-next-line import/prefer-default-export
export const BaseTypography = styled.div<TypographyProps>`
  width: ${({ width = "100%" }) => width};

  margin: ${({ margin = "0" }) => margin};
  padding: ${({ padding = "0" }) => padding};

  font-family: "Campton";
  font-size: ${({ size = "18px" }) => size};
  text-align: ${({ align = "18px" }) => align};
  font-weight: ${({ weight = "700" }) => weight};
  text-transform: ${({ transform = "none" }) => transform};
  ${({ cursor }) => cursor && `cursor:${cursor};`};
  letter-spacing: ${({ letterSpacing = "0.1px" }) => letterSpacing};
  color: ${({ color }) => color};
  word-break: ${({ wordBreak }) => wordBreak};
  ${({ decoration }) => decoration && `text-decoration:${decoration};`};
  ${({ disabled }) => disabled && `pointer-events: none;`};

  background-color: ${({ backgroundColor }) => backgroundColor};

  border-radius: ${({ borderRadius }) => borderRadius};

  :hover {
    ${({ hoverDecoration }) =>
      hoverDecoration && `text-decoration:${hoverDecoration};`};
    ${({ hoverColor }) => hoverColor && `color:${hoverColor};`};
  }

  @media ${MEDIA_QUERIES.MOBILE} {
    
    ${({ display = "contents" }) => display && `display:${display};`};

    ${({ display }) => (display == "flex" ? "width: auto;" : "width: 100%;")}
`;
